<template>
  <div class="privacy-page">
    <!-- 横幅部分 -->
    <section class="hero-banner bg-orange-500 py-16 lg:py-20">
      <div class="max-w-7xl mx-auto px-4 lg:px-8">
        <div class="flex flex-col lg:flex-row items-center justify-between gap-8 lg:gap-12">
          <!-- 左侧内容 -->
          <div class="flex-1 text-center lg:text-left">
            <h1 class="text-3xl lg:text-4xl xl:text-5xl font-bold text-white mb-6 leading-tight">
              {{ $t('privacy.title') }}
            </h1>
            <p class="text-xl text-white mb-0 opacity-90">
              {{ $t('privacy.subtitle') }}
            </p>
          </div>

          <!-- 右侧图标 -->
          <div class="flex-shrink-0 w-64 h-64 lg:w-80 lg:h-80">
            <img src="/assets/23@1x.png" alt="隐私政策" class="w-full h-full object-contain">
          </div>
        </div>
      </div>
    </section>

    <!-- 主要内容 -->
    <section class="content-section py-16 bg-white">
      <div class="max-w-4xl mx-auto px-4 lg:px-8">
        <div class="prose max-w-none">
          <p class="text-gray-600 italic mb-8">{{ $t('privacy.lastUpdated') }}</p>

          <h2>{{ $t('privacy.sections.intro.title') }}</h2>
          <p>{{ $t('privacy.sections.intro.content') }}</p>

          <h2>{{ $t('privacy.sections.collection.title') }}</h2>
          <p>{{ $t('privacy.sections.collection.content') }}</p>

          <h2>{{ $t('privacy.sections.usage.title') }}</h2>
          <p>{{ $t('privacy.sections.usage.content') }}</p>

          <h2>{{ $t('privacy.sections.sharing.title') }}</h2>
          <p>{{ $t('privacy.sections.sharing.content') }}</p>

          <h2>{{ $t('privacy.sections.security.title') }}</h2>
          <p>{{ $t('privacy.sections.security.content') }}</p>

          <h2>{{ $t('privacy.sections.cookies.title') }}</h2>
          <p>{{ $t('privacy.sections.cookies.content') }}</p>

          <h2>{{ $t('privacy.sections.userRights.title') }}</h2>
          <p>{{ $t('privacy.sections.userRights.content') }}</p>

          <h2>{{ $t('privacy.sections.dataRetention.title') }}</h2>
          <p>{{ $t('privacy.sections.dataRetention.content') }}</p>

          <h2>{{ $t('privacy.sections.children.title') }}</h2>
          <p>{{ $t('privacy.sections.children.content') }}</p>

          <h2>{{ $t('privacy.sections.policyChanges.title') }}</h2>
          <p>{{ $t('privacy.sections.policyChanges.content') }}</p>

          <h2>{{ $t('privacy.sections.contact.title') }}</h2>
          <p>{{ $t('privacy.sections.contact.content') }}</p>

          <div class="mt-12 p-6 bg-orange-50 rounded-lg border border-orange-200">
            <h3 class="text-lg font-semibold text-orange-900 mb-2">{{ $t('privacy.commitment.title') }}</h3>
            <p class="text-orange-800">{{ $t('privacy.commitment.content') }}</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicyPage',
  metaInfo: {
    title: '隐私政策 - 红土证券'
  }
};
</script>

<style scoped>
.hero-banner {
  background: #ef7c5b;
  position: relative;
  overflow: hidden;
}

.hero-banner::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><defs><pattern id="grain" width="100" height="100" patternUnits="userSpaceOnUse"><circle cx="25" cy="25" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="75" cy="75" r="1" fill="rgba(255,255,255,0.1)"/><circle cx="50" cy="10" r="0.5" fill="rgba(255,255,255,0.1)"/><circle cx="10" cy="50" r="0.5" fill="rgba(255,255,255,0.1)"/><circle cx="90" cy="30" r="0.5" fill="rgba(255,255,255,0.1)"/></pattern></defs><rect width="100" height="100" fill="url(%23grain)"/></svg>');
  opacity: 0.3;
}

.content-section {
  min-height: 600px;
}

/* 富文本内容样式 */
.prose >>> h1 {
  font-size: 1.875rem;
  font-weight: 700;
  margin-top: 1.5em;
  margin-bottom: 0.75em;
  line-height: 1.2;
  color: #111827;
}

.prose >>> h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 2em;
  margin-bottom: 0.75em;
  line-height: 1.3;
  color: #111827;
  padding-bottom: 0.5em;
  border-bottom: 2px solid #f97316;
}

.prose >>> h3 {
  font-size: 1.25rem;
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.4;
  color: #111827;
}

.prose >>> p {
  margin-top: 0.5em;
  margin-bottom: 1em;
  line-height: 1.75;
  color: #4b5563;
}

.prose >>> ul {
  list-style-type: disc;
  padding-left: 1.5em;
  margin-top: 0.75em;
  margin-bottom: 1em;
}

.prose >>> ol {
  list-style-type: decimal;
  padding-left: 1.5em;
  margin-top: 0.75em;
  margin-bottom: 1em;
}

.prose >>> li {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
  line-height: 1.75;
  color: #4b5563;
}

.prose >>> li::marker {
  color: #f97316;
}

.prose >>> strong {
  font-weight: 700;
  color: #111827;
}

.prose >>> em {
  font-style: italic;
}

.prose >>> a {
  color: #ea580c;
  text-decoration: underline;
  transition: color 0.2s;
}

.prose >>> a:hover {
  color: #c2410c;
}

.prose >>> ul ul,
.prose >>> ol ul,
.prose >>> ul ol,
.prose >>> ol ol {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

/* 移动端响应式调整 */
@media (max-width: 768px) {
  .hero-banner {
    padding: 3rem 1rem;
  }

  .hero-banner h1 {
    font-size: 1.75rem;
  }

  .content-section {
    padding: 3rem 1rem;
  }
}
</style>
